/*--------------------------------------------------------
 * Author Trần Đức Tiến
 * Email ductienas@gmail.com
 * Phone 0972970075
 * Created: 2017-05-27 12:55:55
 *
 * LastModified: 2017-05-27 12:55:55
 *-------------------------------------------------------*/

const defaultState = {
  data: [],
  countArr: [0, 0, 0]
}

function listGlasses(state = defaultState, action) {
  switch (action.type) {
    case 'RESET_ALL_GLASSES_STATE':
      return defaultState
    case 'GET_ALL_GLASSES_SUCCESS':
      return action.payload
    case 'UPDATE_MODEL_TYPE': {
      const { id, modelType } = action.payload
      const newData = [...state.data]
      const updatedIdx = newData.findIndex(product => product.id === id)
      if (updatedIdx >= 0) {
        newData[updatedIdx].modelType = modelType
      }
      return {
        ...state,
        data: newData
      }
    }
    default:
      return state
  }
}

function totalDownloadCount(state = 0, action) {
  switch (action.type) {
    case 'GET_TOTAL_DOWNLOAD_COUNT_SUCCESS':
      return action.payload.downloadCount
    default:
      return state
  }
}

export default {
  listGlasses,
  totalDownloadCount
}



// WEBPACK FOOTER //
// ./routes/app/routes/glasses-list/reducer/index.js